import type { IconProp } from '@fortawesome/fontawesome-svg-core/index';
import { ROLE } from 'services/assist-api/entities/role/roles';

export const friendlyRoles = {
  [ROLE.SITE_ADMIN]: 'Site Admin',
  [ROLE.ADMIN]: 'Admin',
  [ROLE.TEACHER]: 'Teacher',
  [ROLE.LEARNER]: 'Learner',
  [ROLE.PRODUCT_ADMIN]: 'Product Admin',
  [ROLE.CUSTOMER_GROUP_LEADER]: 'Cluster Admin',
  [ROLE.MARKING_ADMIN]: 'Marking Admin',
  [ROLE.MARKER]: 'Marker'
};

export function friendlyRole(role: string): string | undefined {
  return friendlyRoles[role] || undefined;
}

export const roleIcons = {
  [ROLE.SITE_ADMIN]: 'user-secret',
  [ROLE.ADMIN]: 'crown',
  [ROLE.TEACHER]: 'chalkboard-user',
  [ROLE.LEARNER]: 'child',
  [ROLE.PRODUCT_ADMIN]: 'briefcase',
  [ROLE.CUSTOMER_GROUP_LEADER]: 'circle-nodes',
  [ROLE.MARKING_ADMIN]: 'user-pen',
  [ROLE.MARKER]: 'pen-to-square'
};

// Returns the Font Awesome icon prop for the specified role:
export function roleIconProp(role: string): IconProp | null {
  return roleIcons[role] as IconProp;
}
